/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const PagesForMac32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <defs>
            <linearGradient id="prefix__a" x1="11.253%" x2="88.503%" y1="18.933%" y2="80.873%">
                <stop offset="11%" stopColor="#686969" />
                <stop offset="100%" stopColor="#161717" />
            </linearGradient>
            <linearGradient id="prefix__b" x1="6.638%" x2="88.851%" y1="21.429%" y2="73.979%">
                <stop offset="0%" stopColor="#C2EDFF" />
                <stop offset="15%" stopColor="#DEF5FF" />
                <stop offset="55%" stopColor="#C2EDFF" />
                <stop offset="88%" stopColor="#607A7A" />
            </linearGradient>
            <linearGradient id="prefix__c" x1="29.124%" x2="73.53%" y1="48.158%" y2="65.598%">
                <stop offset="0%" stopColor="#C2EDFF" />
                <stop offset="11%" stopColor={vars.white} />
                <stop offset="55%" stopColor="#C2EDFF" />
                <stop offset="88%" stopColor="#C2EDFF" />
            </linearGradient>
            <linearGradient id="prefix__d" x1="47.457%" x2="54.13%" y1="43.432%" y2="54.602%">
                <stop offset="0%" stopColor="#E28D0C" />
                <stop offset="18%" stopColor="#FEDB65" />
                <stop offset="46%" stopColor="#F27D09" />
                <stop offset="73%" stopColor="#D05904" />
                <stop offset="100%" stopColor="#973E07" />
            </linearGradient>
            <linearGradient id="prefix__e" x1="43.752%" x2="56.337%" y1="44.477%" y2="54.957%">
                <stop offset="0%" stopColor="#AE988A" />
                <stop offset="100%" stopColor="#8A715E" />
            </linearGradient>
            <linearGradient id="prefix__f" x1="43.233%" x2="56.766%" y1="44.966%" y2="55.556%">
                <stop offset="0%" stopColor="#9ECDF7" />
                <stop offset="100%" stopColor="#CFE6FF" />
            </linearGradient>
            <linearGradient id="prefix__g" x1="42.532%" x2="57.466%" y1="43.63%" y2="54.47%">
                <stop offset="0%" stopColor={vars.white} />
                <stop offset="100%" stopColor="#E3F0FF" />
            </linearGradient>
            <linearGradient id="prefix__h" x1="40.557%" x2="56.905%" y1="39.016%" y2="56.156%">
                <stop offset="0%" stopColor="#363838" />
                <stop offset="18%" stopColor="#686969" />
                <stop offset="100%" stopColor="#161717" />
            </linearGradient>
            <linearGradient id="prefix__i" x1="44.594%" x2="56.175%" y1="41.544%" y2="56.654%">
                <stop offset="0%" stopColor="#E28D0C" />
                <stop offset="18%" stopColor="#FEDB65" />
                <stop offset="46%" stopColor="#F27D09" />
                <stop offset="73%" stopColor="#D05904" />
                <stop offset="100%" stopColor="#973E07" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#969696"
                d="M22.687 0c3.2 0 4.363.356 5.525.985a6.677 6.677 0 012.803 2.803c.63 1.162.985 2.325.985 5.525v13.374c0 3.2-.356 4.363-.985 5.525a6.677 6.677 0 01-2.803 2.803c-1.162.63-2.325.985-5.525.985H9.313c-3.2 0-4.363-.356-5.525-.985a6.677 6.677 0 01-2.803-2.803C.355 27.05 0 25.887 0 22.687V9.313c0-3.2.356-4.363.985-5.525A6.677 6.677 0 013.788.985C4.95.355 6.113 0 9.313 0h13.374z"
            />
            <path
                fill={vars.white}
                d="M9.313.547h13.374c3.05 0 4.157.315 5.265.916a6.36 6.36 0 012.585 2.585c.601 1.108.916 2.215.916 5.265v13.374c0 3.05-.315 4.157-.916 5.265a6.36 6.36 0 01-2.585 2.585c-1.108.601-2.215.916-5.265.916H9.313c-3.05 0-4.157-.315-5.265-.916-1.108-.602-1.997-1.463-2.585-2.585-.588-1.121-.916-2.215-.916-5.265V9.313c0-3.05.315-4.157.916-5.265.602-1.108 1.463-1.997 2.585-2.585C5.169.875 6.263.547 9.313.547z"
            />
            <path
                fill="#FBA829"
                fillRule="nonzero"
                d="M5.497 10.926c.561 0 .985-.205 1.286-.629.3-.423.451-.93.451-1.504-.492-.027-.902-.191-1.23-.492a1.458 1.458 0 01-.494-1.135c0-.465.164-.848.492-1.163a2.71 2.71 0 011.218-.656l-.165-.424a4.075 4.075 0 00-1.64.656c-.507.342-.93.766-1.245 1.286a3.342 3.342 0 00-.479 1.764c0 .684.164 1.245.493 1.655.328.41.765.642 1.312.642zm4.705 0c.56 0 .984-.205 1.285-.629.301-.423.451-.93.451-1.504-.492-.027-.902-.191-1.23-.492a1.46 1.46 0 01-.493-1.135c0-.465.164-.848.493-1.163a2.7 2.7 0 011.217-.656l-.164-.424a4.084 4.084 0 00-1.641.656 4.14 4.14 0 00-1.245 1.286 3.35 3.35 0 00-.478 1.764c0 .684.164 1.245.492 1.655.328.41.766.642 1.313.642z"
            />
            <path
                fill="#973E07"
                fillRule="nonzero"
                d="M16.738 13.402a.459.459 0 00.041.328l2.312 1.354s.218.054.273-.041c0 0 .26-.63-.943-1.231-1.204-.615-1.491-.506-1.683-.41z"
            />
            <circle cx={9.477} cy={28.417} r={1} fill="url(#prefix__a)" fillRule="nonzero" />
            <path
                fill="url(#prefix__b)"
                fillRule="nonzero"
                d="M9.326 28.226c0 .04.028.068.055.082a.462.462 0 01.233.15c.013.027.027.055.013.068 0 0 .028.055.082-.027l.165-.164a.294.294 0 00-.15-.26.626.626 0 00-.343-.096l-.055.247z"
            />
            <path
                fill="#B98421"
                fillRule="nonzero"
                d="M23.37 3.159s.165-.178.835.014c0 0 1.121.273 1.19 1.271L23.37 3.16z"
            />
            <path
                fill="url(#prefix__c)"
                fillRule="nonzero"
                d="M10.01 25.19l-.71 2.83c.136 0 .259.055.355.137.191.15.15.233.15.233l.069.013c.013 0 .04 0 .054-.013l2.134-1.874a2.426 2.426 0 00-2.052-1.326z"
            />
            <path
                fill="url(#prefix__d)"
                fillRule="nonzero"
                d="M16.738 13.402l6.469-10.147s.191-.274 1.012-.028c.465.123.861.424 1.094.848a.828.828 0 01.068.602l-6.003 10.366c-.028.027-.055.054-.096.054 0 0 .082-.04.082-.109 0-.041 0-.082-.014-.123a1.878 1.878 0 00-.273-.451 3.6 3.6 0 00-1.627-.999 1.228 1.228 0 00-.588-.04c-.083.027-.137.095-.124.177 0 0-.04-.11 0-.15z"
            />
            <path
                fill="#4A5E5E"
                fillRule="nonzero"
                d="M11.897 26.202l-.205-.246c-.04-.028-.082-.055-.123-.082l-1.832 2.324c.04.041.082.096.082.15l2.12-2.092-.042-.054z"
            />
            <path
                fill="url(#prefix__e)"
                fillRule="nonzero"
                d="M23.385 4.198l-4.814 7.809c-.178.287-.356.191-.356.191l-.287-.11c-.082-.054-.15-.122-.219-.19-.027-.028-.04-.055-.04-.096s.013-.069.04-.096l4.992-7.986c.096-.137.178-.082.178-.082l.396.136a.174.174 0 01.137.164c0 .083-.014.165-.027.26z"
            />
            <path
                fill="url(#prefix__f)"
                fillRule="nonzero"
                d="M17.71 11.884l.41.15s.164.096.355-.191l4.964-7.905a.187.187 0 00-.136-.177l-.397-.137s-.096-.082-.205.068l-4.992 7.973a.147.147 0 00-.04.096c0 .027.013.11.04.123z"
            />
            <path
                fill="url(#prefix__g)"
                fillRule="nonzero"
                d="M18.407 11.706c-.178.287-.356.191-.356.191l-.383-.15c-.013.055 0 .096.041.137l.41.15s.165.096.356-.191l4.964-7.905a.167.167 0 00-.068-.136l-4.964 7.904z"
            />
            <path
                fill="url(#prefix__h)"
                fillRule="nonzero"
                d="M12.075 26.503l3.077-4.841a1.452 1.452 0 00-.52-.657 3.433 3.433 0 00-.71-.451 2.7 2.7 0 00-1.081-.274l-2.83 4.923a2.5 2.5 0 011.148.424c.383.192.697.506.916.876z"
            />
            <path
                fill="url(#prefix__i)"
                fillRule="nonzero"
                d="M16.752 13.744s.137-.342.657-.178c.382.123.752.3 1.08.547.26.164.479.396.643.656 0 0 .095.137-.123.465l-3.898 6.469c-.11-.26-.3-.493-.52-.657a2.527 2.527 0 00-.67-.492 2.69 2.69 0 00-1.08-.274l3.911-6.536z"
            />
            <path fill="#4A5E5E" fillRule="nonzero" d="M9.764 28.198l-.191.233.027.041.232-.205z" />
        </g>
    </AccessibleSVG>
);

export default PagesForMac32;
